import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

export const ComboBox = (props) => {
  return (
   <> <Autocomplete
    {...props}          
    getOptionLabel={(option) => props.labelprop ? (option[props.labelprop] ? option[props.labelprop].toString() : '') : (option.label ? option.label : '')}
    onChange={props.onChange}    
    options={props.options}     
    renderInput={(params) => <TextField {...params} helperText={props.helperText} label={props.label} error={props.error} variant="outlined" required={props.required} />}
    />
   
    </>
  );
}